import { makeStyles } from "@material-ui/core";
import WhiteFadedBg from "../../assets/images/white-faded-bg.jpg";
import FeaturedCarouselBg from "../../assets/images/wave-bg.jpg";
import CategoryBg from "../../assets/images/category-bg-img.jpg";

export default makeStyles(() => ({
  root: { "& *": { fontFamily: "Product Sans" } },
  dash: { height: 5, width: 60, backgroundColor: "#283e77" },
  imageContainer: { display: "flex", "& > *": { margin: 12 } },
  gridList: { marginTop: 12, margin: "auto", maxWidth: 1120, width: "100%" },
  link: { textDecoration: "none", color: "inherit" },
  offeredProductBox: {
    background: `url(${WhiteFadedBg}) repeat`,
  },
  hotProductsBox: {
    background: `url(${WhiteFadedBg}) repeat`,
    paddingTop: "30px",
    paddingBottom: "30px",
  },
  catogoriesList: {
    backgroundColor: "#ebebeb",
    backgroundImage: `url(${CategoryBg})`,
    backgroundPosition: 'bottom center',
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  featuredCarousel: {
    backgroundImage: `url(${FeaturedCarouselBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
}));
